import React, { useCallback, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { ForeignData_API } from "../../../../APIs/ForeignData.api";
import { TRUE } from "sass";
import FileImageUpdate from "../../../../cpn/inputs/file-image-update";
import { Table } from "react-bootstrap";
import { components } from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashCan } from "@fortawesome/free-solid-svg-icons";

export default function RenderInputsPXK({
  field: f,
  options,
  selectedValues,
  setSelectedValues,
  control,
  register,
  setValue,
  getValues,
  isChild,
  refresh,
  dataSuggest,
  showDataSuggest,
  setShowDataSuggest,
  setDataSuggest,
}) {
  const { lang, proxy, functions } = useSelector((state) => state);
  const { filterData } = functions;
  const {
    type,
    alias,
    readOnly,
    table_id,
    displayFields,
    style,
    name,
    required,
    betChar,
    isPK,
    isMulti,
    isButton,
    isModal,
    isApi,
    isTable,
  } = f;
  const value = getValues(alias);

  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };
  switch (type) {
    case "input-select":
      return (
        <div>
          {isChild && (
            <label
              class="form-label"
              style={{
                position: "absolute",
                top: "-27px",
                right: "-5px",
              }}
            >
              {name}
              {required && <span style={{ color: "red" }}>*</span>}
            </label>
          )}
          <select
            className="form-control"
            aria-label="Default select example"
            {...register(alias)}
            value={value}
            style={style}
          >
            <option></option>
            {options.length &&
              options.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
      );

    case "select":
      return (
        <Controller
          name={alias}
          control={control}
          defaultValue=""
          render={({ field }) => (
            <>
              <div className="d-flex justify-content-between">
                <AsyncPaginate
                  placeholder={lang["select value"]}
                  className="mb-0 w-100"
                  {...field}
                  loadOptions={async (search, loadedOptions, { page }) => {
                    return await loadOptions(
                      page,
                      search,
                      displayFields,
                      table_id,
                      proxy,
                      isPK,
                      isApi
                    );
                  }}
                  key={alias}
                  value={selectedValues?.[alias] || null}
                  onChange={(opt) => {
                    if (isMulti || isModal?.id) {
                      setSelectedValues((prev) => {
                        const newPrev = { ...prev };
                        newPrev[alias] = opt.map((item) => ({
                          label: item?.label,
                          value: item?.value,
                          ...item,
                        }));
                        return newPrev;
                      });
                      if (isModal?.id) {
                        setDataSuggest((prev) => {
                          const newPrev = { ...prev };
                          newPrev["2LGH"] = opt;
                          return newPrev;
                        });
                        setShowDataSuggest(true);
                      }
                      setValue(
                        alias,
                        opt.map((item) => item?.value)
                      );
                    } else {
                      setValue(alias, opt?.value);

                      setSelectedValues((prev) => {
                        const newPrev = { ...prev };
                        newPrev[alias] = opt;
                        return newPrev;
                      });
                    }
                    return opt;
                  }}
                  additional={{ page: 0 }}
                  isSearchable={true}
                  allowCreateWhileLoading={false}
                  noOptionsMessage={() => (
                    <div style={{ fontWeight: "300" }}>
                      {lang["not found data"]}
                    </div>
                  )}
                  //   isDisabled={alias === "2LGH" && true}
                  isClearable={true}
                  styles={{
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  isMulti={isMulti}
                  closeMenuOnSelect={isMulti && false}
                  components={{
                    Option: isMulti ? CustomOption : components.Option,
                  }}
                />
                {isButton?.state && isModal?.id ? (
                  <>
                    <button
                      className="btn btn-success ml-4 mt-0"
                      type="button"
                      data-toggle="modal"
                      data-target={`#${isModal.id}`}
                      data-backdrop="static"
                    >
                      {isButton?.text || lang["add"]}
                    </button>
                    <div
                      class="modal fade"
                      id={isModal.id}
                      tabindex="-1"
                      aria-labelledby="renderModalTest"
                      aria-hidden="true"
                      data-backdrop="static"
                    >
                      <div className="modal-dialog">
                        <div className="modal-content custome">
                          <div className="modal-header justify-content-start">
                            <span style={{ fontSize: "18px" }}>
                              {lang[isModal?.text]}
                            </span>
                          </div>
                          <div
                            className="modal-body"
                            style={{
                              height: "70vh",
                              overflowY: "auto",
                              overflowX: "unset",
                            }}
                          >
                            <form
                              className=""
                              style={{
                                padding: "5px 5em",
                              }}
                            >
                              {isModal?.fields?.map((field, index) => {
                                return (
                                  <div className="form-group mb-3" key={index}>
                                    <label className="form-label">
                                      {field.name}
                                      {field.required && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>
                                    {RenderInputsPXK({
                                      field,
                                      options,
                                      selectedValues,
                                      setSelectedValues,
                                      control,
                                      register,
                                      setValue,
                                      getValues,
                                      isChild: true,
                                      refresh,
                                      dataSuggest,
                                      showDataSuggest,
                                      setShowDataSuggest,
                                      setDataSuggest,
                                    })}
                                  </div>
                                );
                              })}
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button
                              type="button"
                              class="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              {lang["btn.close"]}
                            </button>
                            <button
                              type="button"
                              class="btn btn-primary"
                              data-dismiss="modal"
                              onClick={() => {
                                setDataSuggest((prev) => {
                                  const newPrev = { ...prev };
                                  newPrev[alias] = [
                                    ...(newPrev[alias] || []),
                                    ...[selectedValues["LGH"]],
                                  ];
                                  return newPrev;
                                });
                                setSelectedValues((prev) => {
                                  const newPrev = { ...prev };
                                  newPrev[alias] = [
                                    ...(newPrev[alias] || []),
                                    selectedValues["LGH"],
                                  ];
                                  newPrev["LGH"] = null;
                                  return newPrev;
                                });
                                setShowDataSuggest(true);
                              }}
                            >
                              {lang["btn.update"]}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : isButton?.state ? (
                  <button
                    className="btn btn-success m-0 ml-4"
                    type="button"
                    onClick={() => {
                      setShowDataSuggest(true);
                      setSelectedValues((prev) => {
                        const newPrev = { ...prev };
                        newPrev["3MLĐB"] = dataSuggest?.["3MLĐB"]?.map(
                          (item) => ({
                            label: item?.label,
                            value: item?.value,
                          })
                        );
                        return newPrev;
                      });
                      setValue(
                        "3MLĐB",
                        dataSuggest?.["3MLĐB"]?.map((item) => item?.value)
                      );
                    }}
                  >
                    {isButton.text}
                  </button>
                ) : null}
              </div>
              {isTable && (
                <div style={{ overflow: "auto" }}>
                  <Table className="table table-custom mt-3">
                    <thead>
                      <tr>
                        <td className="align-center">#</td>
                        {isTable?.headers?.map((h) => {
                          return <td>{h.label}</td>;
                        })}
                        <td>Thao Tác</td>
                      </tr>
                    </thead>
                    <tbody>
                      {dataSuggest?.[alias]?.length && showDataSuggest ? (
                        dataSuggest?.[alias]?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              {isTable?.headers?.map((h, i) => {
                                return (
                                  <>
                                    <td
                                      className="align-center"
                                      style={{
                                        color: h?.color,
                                        textAlign: "left",
                                        whiteSpace: "pre",
                                        // textAlign: "center",
                                      }}
                                    >
                                      {h?.type ? (
                                        <input
                                          className="form-control"
                                          defaultValue={
                                            item[h.field] || item[h.alias]
                                          }
                                          type={h?.type}
                                          readOnly={h?.readOnly}
                                          onChange={(e) => {
                                            let { value } = e.target;
                                            value =
                                              h?.type === "number"
                                                ? Number(value)
                                                : value;

                                            setDataSuggest((prev) => {
                                              const newPrev = { ...prev };
                                              newPrev[alias][index][
                                                h.field || h.alias
                                              ] = value;
                                              return newPrev;
                                            });
                                          }}
                                          min={0}
                                        />
                                      ) : (
                                        <div
                                          className={`${
                                            h.alias !== "SanPham" &&
                                            `text-center`
                                          }`}
                                        >
                                          {item?.[h.field] || item?.[h.alias]}
                                        </div>
                                      )}
                                    </td>
                                  </>
                                );
                              })}
                              <td>
                                <button className="btn btn-success m-0">
                                  <FontAwesomeIcon
                                    icon={faEdit}
                                    // data-toggle="modal"
                                    // data-target={`#modalEdit`}
                                    // data-backdrop="static"
                                  />
                                </button>
                                <button className="btn btn-danger m-0 ml-2">
                                  <FontAwesomeIcon icon={faTrashCan} />
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan={isTable?.headers?.length + 2}
                            className="align-center"
                          >
                            {lang["not found data"]}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </>
          )}
        />
      );

    case "textarea":
      return (
        <textarea
          rows={4}
          {...register(alias)}
          className="form-control"
          readOnly={readOnly}
        />
      );

    case "number":
      return Input(
        dataSuggest,
        setDataSuggest,
        type,
        alias,
        register,
        readOnly,
        0
      );
    case "float":
      return Input(
        dataSuggest,
        setDataSuggest,
        type,
        alias,
        register,
        readOnly,
        0,
        "any",
        setValue
      );
    case "file":
      const files = getValues(alias);
      return (
        <FileImageUpdate
          key={refresh}
          field={alias}
          changeTrigger={(e, value) => {
            setValue(alias, value);
          }}
          defaultValue={files}
          isMultiple={true}
          col="col-sm-12"
          refresh={refresh}
          isCustom={true}
        />
      );
    case "text":
    default:
      return Input(
        dataSuggest,
        setDataSuggest,
        type,
        alias,
        register,
        readOnly
      );
  }
}

const loadOptions = async (
  page = 0,
  search = "",
  displayFields,
  table_id,
  proxy,
  isPK,
  isApi
) => {
  return new Promise(async (resolve, reject) => {
    let dataBody = {
      table_id,
      start_index: page,
      type: "or",
    };

    let newData = {
      options: [],
      hasMore: false,
      additional: {
        page: 0,
      },
    };
    if (search) {
      let criteria = {};
      let criteria_type = {};
      displayFields.forEach((field) => {
        criteria[field] = search.trim();
        criteria_type[field] = "regex";
      });

      dataBody.criteria = criteria;
      dataBody.criteria_type = criteria_type;
    }

    const _token = localStorage.getItem("_token");
    try {
      const { data } = isApi
        ? await fetch(proxy() + isApi, {
            method: "POST",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
              "data-amount": 100,
            },
            body: JSON.stringify(dataBody),
          }).then((res) => res.json())
        : await ForeignData_API.get(proxy(), _token, dataBody);
      let hasMoreValue = true;

      if (!data?.length) {
        hasMoreValue = false;
      }

      if (data.length) {
        const options = data.flatMap((item) => {
          const hasArrayField = displayFields.find((field) =>
            Array.isArray(item[field])
          );
          if (!hasArrayField) {
            return [
              {
                label: displayFields
                  .map((field) => item[field])
                  .filter(Boolean)
                  .join("|"),
                value: item?.[isPK],
                ...item,
              },
            ];
          }

          const arrayField = hasArrayField;
          const arrayValues = item[arrayField];

          return arrayValues.map((val) => {
            const clonedItem = { ...item, [arrayField]: val };
            return {
              label: displayFields
                .map((field) => clonedItem[field])
                .filter(Boolean)
                .join("|"),
              value: clonedItem?.[isPK],
              ...clonedItem,
            };
          });
        });

        newData = {
          options,
          hasMore: hasMoreValue,
          additional: {
            page: hasMoreValue ? page + 15 : page,
          },
        };
      }

      setTimeout(() => {
        resolve(newData);
      }, 100);
    } catch (error) {
      console.error("Error in loadOptions:", error);
      reject(error);
    }
  });
};

const Input = (
  dataSuggest,
  setDataSuggest,
  type,
  alias,
  register,
  readOnly,
  min,
  step,
  setValue
) => {
  return (
    <input
      {...register(alias, { valueAsNumber: type === "number" })}
      type={type === "float" ? "number" : type}
      className="form-control"
      readOnly={readOnly}
      min={min}
      step={step}
      onChange={(e) => {
        let { value } = e.target;

        value = type === "float" ? Number(value) : value;

        if (dataSuggest) {
          setDataSuggest((prev) => {
            const newPrev = { ...prev };
            const length = newPrev["2LGH"].length - 1;

            newPrev["2LGH"][length] = {
              ...newPrev["2LGH"][length],
              [alias]: value,
            };

            return newPrev;
          });
        }
      }}
      onBlur={(e) => {
        const { value } = e.target;
        if (type === "float" && value) {
          const roundedValue = parseFloat(value).toFixed(3);
          const parseValue = Number(roundedValue);
          setValue(alias, parseValue);
        }
      }}
      // max="999"
      // maxLength="3"
    />
  );
};
